import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { TChatDataInListSchema } from '../../../types/chatList';
import { TChatList } from '../../types/chatList';
import { SliceActions } from '../types';

const initialState: TChatList = [];

const chatListSlice = createSlice({
  name: 'chatList',
  reducers: {
    addChat: (state, action: PayloadAction<TChatDataInListSchema>) => {
      const existingChatIndex = state.findIndex(c => c.chatId === action.payload.chatId);
      if (existingChatIndex !== -1) {
        state[existingChatIndex] = action.payload;
      } else {
        state.push(action.payload);
      }
    },
  },
  selectors: {
    selectAllChats: state => state,
  },
  initialState,
});

export const chatListReducer = chatListSlice.reducer;
export const { addChat } = chatListSlice.actions;
export const { selectAllChats } = chatListSlice.selectors;
export type TChatListActions = SliceActions<typeof chatListSlice.actions>;
